import React, { Fragment } from "react";
import ThisTable from "../../../Common/ThisTable";
import { ButtonActionsTable } from "../../../Common/Buttons";
import { languageService } from "../../../../Language/language.service";
import moment from "moment";

function TestDisplayList(data, handleViewClick, handleDeleteClick) {
  const columns = [
    { Header: "Test", id: "test", accessor: (row) => row.title },
    { Header: "Location", id: "location", accessor: (row) => ((row.formData || []).find((f) => f.id === "locationName") || {}).value },
    { Header: "Performed By", id: "performedBy", accessor: (row) => row.performedByUser && row.performedByUser.name },
    { Header: "Performed Date", id: "date", accessor: (row) => row.date && moment(row.date).format("ll") },
    { Header: "Certified By", id: "certifiedBy", accessor: (row) => row.certifiedByUser && row.certifiedByUser.name },
    { Header: "Certified Date", id: "certifiedDate", accessor: (row) => row.certifiedDate && moment(row.certifiedDate).format("ll") },
    {
      Header: "Blue Card Items",
      id: "bluecardItems",
      minWidth: 180,
      accessor: (row) =>
        (row.formData || [])
          .filter((f) => ["item1", "item2", "item3", "item4", "item5", "item6", "item7"].includes(f.id) && f.value)
          .map((f) => f.fieldName)
          .join(", "),
      Cell: ({ value }) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowY: "auto",
          }}
        >
          {value}
        </div>
      ),
    },
    {
      Header: "Comments",
      id: "comments",
      minWidth: 180,
      accessor: (row) => (row.formData || []).find((f) => f.id === "com" && f.value),
      Cell: ({ value }) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {value && value.value}
        </div>
      ),
    },
    {
      Header: "Action",
      id: "action",
      Cell: ({ row }) => (
        <div style={{ display: "flex" }}>
          <ButtonActionsTable
            handleClick={() => {
              handleViewClick(row._index);
            }}
            margin="0px 10px 0px 0px"
            buttonText={languageService("Edit")}
          />{" "}
          <ButtonActionsTable
            handleClick={() => {
              handleDeleteClick(row._index);
            }}
            margin="0px 10px 0px 0px"
            buttonText={languageService("Delete")}
          />
        </div>
      ),
    },
  ];
  return (
    <ThisTable
      showFilters={false}
      tableColumns={columns}
      tableData={data || []}
      minRows={5}
      pagination={false}
      height={"auto"}
      // forDashboard={true}
    />
  );
}

export default TestDisplayList;



// WEBPACK FOOTER //
// ./src/components/AssetView/BlueCard/InitaializeBlueCard/TestDisplayList.jsx